import React, { useEffect } from 'react';
import * as ReactRouterDom from 'react-router-dom';
import { useMutation } from 'react-query';
import { Button } from '@material-ui/core';
import { useSelector } from 'react-redux';
import { useBuyProcessForm } from '../..';
import { ButtonLoading } from '../../../form/components/button-loading/button-loading';
import { When } from '../../../../packages/when/when';
import { Routing } from '../../../../global';
import { ErrorType } from '../../../../global/types/error';
import api from '../../../../global/api';
import { BuyProcessApiRequest } from '../../../../global/entities/BuyOrder';
import {
  useCreateNotificationError,
  useNotifications,
} from '../../../notifications/use-notifications';
import { useDeleteBuyOrderStore } from '../../../admin/buy-process/buy-order-edit/use-buy-order-edit';
import { SubmitActions } from '../submit-actions/submit-actions';
import { onGoBackInForm } from '../../use-buy-process-form';
import { useIsAdminOnBuyOrderEditForm } from '../../../../utils/buy-order/use-is-admin-on-buy-order-edit-form';
import { BuyProcessServices } from '../../../../services';
import { selectBuyUpdateRequestFactory } from '../../../../services/buy-process/update-order/selectors';
import { SummaryDisplay } from './components/summary-display';

export const BuyProcessFormSummary = () => {
  const notifications = useNotifications();
  const match = ReactRouterDom.useRouteMatch();
  const history = ReactRouterDom.useHistory();

  const { id, goToRequestedStep, setRequestedStep } = useBuyProcessForm();
  const { resetBuyOrder } = useDeleteBuyOrderStore(id);

  async function onBack(event: React.MouseEvent<HTMLButtonElement>) {
    await onGoBackInForm(
      setRequestedStep,
      () => new Promise((resolve) => resolve(true)),
      event,
    );
  }

  const [createOrder, createOrderMeta] = useMutation<any, ErrorType, any>(
    async (order: BuyProcessApiRequest) => {
      const response = await api.post('/orders/buy', order);
      return response.data;
    },
    {
      onSuccess: () => {
        notifications.success({
          description:
            'Du har skapat en beställning! Du kommer att omdirigeras tillbaka till hemsidan om 3 sekunder!',
        });

        setTimeout(() => {
          history.replace(Routing.ThankYou);
          resetBuyOrder();
        }, 3000);
      },
    },
  );

  const [onUpdateOrder, updateOrderMeta] = BuyProcessServices.useUpdateBuyOrder(
    id,
    true,
  );

  const mutateFormattedBuyOrder = useSelector(
    selectBuyUpdateRequestFactory(id),
  );

  useCreateNotificationError(createOrderMeta.isError, createOrderMeta.error);

  useEffect(() => {
    goToRequestedStep(true);
  }, [goToRequestedStep]);

  const isAdminOnForm = useIsAdminOnBuyOrderEditForm();

  const isOnCreatePath = match.path === Routing.BuyProcess;

  return (
    <div>
      <When condition={isAdminOnForm}>
        <ButtonLoading
          fullWidth
          style={{ marginBottom: '24px', marginTop: '24px' }}
          onClick={onUpdateOrder}
          loading={updateOrderMeta.isLoading}
          loadingText="Saving..."
          variant="outlined"
          color="primary"
          size="large"
        >
          Spara beställning
        </ButtonLoading>
      </When>

      <SummaryDisplay orderId={id} />

      <When condition={isOnCreatePath}>
        <SubmitActions>
          <Button onClick={onBack}>Tillbaka</Button>
          <ButtonLoading
            disabled={createOrderMeta.isSuccess}
            loading={createOrderMeta.isLoading}
            loadingText="Gör din beställning..."
            variant="contained"
            color="primary"
            onClick={() => createOrder(mutateFormattedBuyOrder)}
          >
            Gör beställning
          </ButtonLoading>
        </SubmitActions>
      </When>
    </div>
  );
};
